import { Pipe, PipeTransform } from '@angular/core';
import { Stations } from 'src/app/services/stations/stations';

@Pipe({
  name: 'filterLocation'
})
export class FilterLocationPipe implements PipeTransform {

  transform(items: any[], searchText: string, object: Stations[]): any[] {
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    var finalItems = [];
    var waitForCode = new Promise<void>((resolve, reject) => {
      var stations = object.filter(item => item.stationVendor.toLowerCase() == searchText);
      stations.forEach((station,index) => {
        console.log(station.locationName);
        if (!finalItems.includes(station.locationName)) {
          finalItems.push(station.locationName);
        }
      });
      resolve();
    })
    waitForCode.then(() => {
      console.log(JSON.stringify(finalItems));
      return finalItems;
    })

    // return items.filter(it => it.locationName.toLowerCase().includes(searchText));
  }

}
